<template>
  <tr class="product">
    <td class="small-cell">{{theShop.name}}</td>
    <td class="small-cell"><p>{{theShop.seller_name}}</p></td>
    <td class="small-cell">{{theShop.mobile}}</td>
    <td class="mid-cell">{{theShop.address}}</td>
    <td class="small-cell">{{theShop.district}}</td>
    <td class="small-cell"><button @click="changeMe" :class="(theShop.active != 1 ? 'purple-btn' : 'red-btn')">{{(theShop.active == 1 ? 'غیر فعال شود' : 'فعال شود')}}</button></td>
    <td class="small-cell"><button @click="slugMe" class="purple-btn ml-2">افزودن سئو</button></td>
    <td class="small-cell"><button @click="goToPanel" class="purple-btn ml-2">ورود به پنل</button><router-link :to="'/admin/shops/'+theShop.id" target="_blank"><button class="purple-btn mt-2 ml-2">محصولات</button></router-link></td>
  </tr>
</template>
<script>
import CustomInput from '../../../Common/CustomInput'
export default {
  props: ["theShop"],
  components:{
    CustomInput
  },
  methods:{
    goToPanel:function(){
      this.$emit('goToPanel',this.theShop.id)
    },
    changeMe:function(){
      this.$emit('changeMe',{id:this.theShop.id,active:this.theShop.active})
    },
    slugMe:function(){
      this.$emit('slugMe',this.theShop.id)
    }
  }
};
</script>
<style scoped>
td {
  border: 1px solid rgba(127, 127, 127, 0.2);
  white-space: pre-wrap;
  padding: 0.5rem;
  word-break: break-all;
}

tr {
  width: 100%;
}

.order-locker img{
    width: 50%;
}

.small-cell{
  max-width: 10%;
}

.mid-cell{
  max-width: 12.5%;
  word-break: break-all;
}

.mid-cell p{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width:25vw;
}

.large-cell{
  width: 15vw;
}

</style>